import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDataContext } from 'common/lib/helpers/DataContext';
import getPath from '@finn-no/search-mfinn-links';
import { isProjectAd } from 'common/lib/helpers/adTypeHelpers';
import Paging from './paging';

const SearchHeader = ({ finnkode, adType }) => {
    const { searchBreadcrumbsUrl, finnUrl } = useDataContext();

    const [breadcrumbs, setBreadcrumbs] = useState(null);
    const [searchKey, setSearchKey] = useState(null);

    useEffect(() => {
        // PTS projects are not indexed in solr so we avoid doing a fetch for these adTypes
        if (!isProjectAd(adType)) {
            fetch(`${searchBreadcrumbsUrl}/breadcrumb?adid=${finnkode}`)
                .then(res => res.json())
                .then(data => {
                    if (data && data.searchKey && data.breadcrumb && data.breadcrumb.length > 0) {
                        setBreadcrumbs(data.breadcrumb);
                        setSearchKey(data.searchKey);
                    } else {
                        setBreadcrumbs(null);
                        setSearchKey(null);
                    }
                })
                .catch(function (err) {
                    console.warn(`Could not fetch search breadcrumbs on ad: ${finnkode}`, err);
                });
        }
    }, []);

    return (
        <div className="flex justify-between gap-x-20 py-8">
            <div>
                {breadcrumbs && searchKey && (
                    <f-breadcrumbs class="mt-10">
                        {breadcrumbs.map(breadcrumb => {
                            const mfinnUrl = new URL(`${getPath(searchKey, breadcrumb.page)}`, finnUrl);
                            return (
                                <a href={mfinnUrl} key={breadcrumb.level}>
                                    {breadcrumb.label}
                                </a>
                            );
                        })}
                    </f-breadcrumbs>
                )}
            </div>
            <Paging finnkode={finnkode} />
        </div>
    );
};

SearchHeader.propTypes = {
    finnkode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    adType: PropTypes.string.isRequired,
};

export default SearchHeader;
